import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { QRCodeCanvas } from 'qrcode.react'
import { toast } from 'react-toastify'
import axios from 'axios'
import { usePlan } from '../../../context/PlanContext'

const InstallBot = () => {
  const navigate = useNavigate()
  const [botLink, setBotLink] = useState('')
  const [copied, setCopied] = useState(false)
  const { currentPlan } = usePlan()
  console.log(currentPlan)
  // Fetch WhatsApp config on mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const token = localStorage.getItem('auth-token')
        if (!token) {
          toast.error('Authentication token missing')
          return
        }

        const res = await axios.get(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/get-WhatsAppConfig?bgAccountId=${currentPlan?.bgAccountId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )

        const config = res.data?.config?.[0]
        if (config?.testNumber) {
          setBotLink(`https://wa.me/${config.testNumber}?text=hi`)
        } else {
          toast.error('Test number not found in config')
        }
      } catch (err) {
        console.error('Error fetching WhatsApp config:', err)
        toast.error('Failed to load WhatsApp config')
      }
    }

    fetchConfig()
  }, [])

  const handleCopy = () => {
    if (!botLink) return
    navigator.clipboard.writeText(botLink)
    setCopied(true)
    toast.success('Link copied to clipboard!')
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className='d-flex justify-content-center align-items-center'>
      {/* Back Button */}
      <button
        className='btn btn-secondary position-absolute'
        style={{
          top: '70px',
          left: '90px'
        }}
        onClick={() => navigate('/whatsapp-bots/all-bots')}
      >
        ← Back
      </button>

      {/* Card */}
      <div
        className='card shadow-lg p-5 text-center'
        style={{
          borderRadius: '20px',
          maxWidth: '450px',
          width: '100%',
          backgroundColor: '#ffffff'
        }}
      >
        <h2 className='mb-3 fw-bold'>Install WhatsApp Bot</h2>
        <p className='text-muted mb-4'>
          Scan the QR code below or copy the link to install and configure your bot.
        </p>

        {botLink ? (
          <>
            <div
              className='p-4 mb-4 rounded'
              style={{ backgroundColor: '#f9fafc', display: 'inline-block' }}
            >
              <QRCodeCanvas value={botLink} size={200} />
            </div>

            <div className='input-group'>
              <input
                type='text'
                className='form-control'
                value={botLink}
                readOnly
                style={{ fontSize: '0.9rem' }}
              />
              <button className='btn btn-primary' type='button' onClick={handleCopy}>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </>
        ) : (
          <p className='text-muted'>Loading WhatsApp config...</p>
        )}
      </div>
    </div>
  )
}

export default InstallBot
